import React from "react";
import AppContext from "./AppContext";

const WithContext = (Component) => {
  return (props) => (
    <AppContext.Consumer>
      {({ state, actions }) => {
        return <Component {...props} state={state} actions={actions} />;
      }}
    </AppContext.Consumer>
  );
};

export default WithContext;
